<app-hero-section></app-hero-section>
<section class="px-5 py-8 lg:py-12 text-center max-w-4xl mx-auto">
    <h1 class="text-2xl lg:text-4xl font-medium text-gray-900">Алое вера гел и Forever Living производи во Македонија</h1>
    <p class="pt-3 text-base lg:text-lg text-gray-700">
        Forever алое вера гел за пиење, пчелни производи, додатоци во исхрана и нега за лице и тело.
        Достава низ цела Македонија и плаќање при достава.
    </p>
</section>
<app-trust-strip></app-trust-strip>
<!-- Best sellers first: on a phone they used to start three and a half screens down. -->
<app-top-products></app-top-products>
<app-testimonials></app-testimonials>
<app-product-category-list></app-product-category-list>
<app-email-form></app-email-form>
<!-- Articles last: they help search engines more than they help someone ready to buy. -->
<app-latest-blog-posts></app-latest-blog-posts>
<app-footer></app-footer>